import { DeferredRenderer } from 'platform-components';
import React from 'react';

import {
    CustomLessonViewButton,
    BUTTON_TYPES,
} from 'common.components/lesson-view.custom-view/__button/custom-lesson-view__button';
import { CustomLessonViewHeaderContainer } from 'common.components/lesson-view.custom-view/__header/custom-lesson-view__header.container';
import { CustomLessonViewWrapper } from 'common.components/lesson-view.custom-view/__wrapper/custom-lesson-view__wrapper';
import { LessonViewResultsWithInformationBanners } from 'common.components/lesson-view.index/__results/lesson-view__results';
import Tabs from 'common.components/lesson-view.index/__tabs/lesson-view__tabs';
import Problems from 'common.components/lesson-view.problems/problems';
import { LESSON_MODAL_TABS } from 'common.components/lesson-view.store/typings';

import './custom-lesson-readonly-view.scss';

interface Props {
    selectedTab: LESSON_MODAL_TABS | null;
}

export const CustomLessonReadonlyView = React.memo((props: Props) => {
    const { selectedTab } = props;

    return (
        <CustomLessonViewWrapper>
            <CustomLessonViewHeaderContainer
                controls={
                    <>
                        <Tabs />
                        <CustomLessonViewButton type={BUTTON_TYPES.TEACHER_DISPLAY} />
                        <CustomLessonViewButton type={BUTTON_TYPES.TEACHER_VIEW_AS_STUDENT} />
                    </>
                }
            />

            <div className={'lesson-view__content-tabs'}>
                {selectedTab === LESSON_MODAL_TABS.STATS && <LessonViewResultsWithInformationBanners />}
                {selectedTab === LESSON_MODAL_TABS.PROBLEMS && (
                    <DeferredRenderer>
                        <Problems canEdit={false} mix="custom-lesson-view__problems" />
                    </DeferredRenderer>
                )}
            </div>
        </CustomLessonViewWrapper>
    );
});
